import { render, staticRenderFns } from "./MemberPlanModal.vue?vue&type=template&id=876cf242&"
import script from "./MemberPlanModal.vue?vue&type=script&lang=js&"
export * from "./MemberPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports